import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Button,
  Box,
} from "@mui/material";

const TimeTableForm = ({
  open,
  onClose,
  coordinators = [],
  selectedSlot,
  selectedEntry,
  cookies,
  onSubmit,
  form,
  setForm,
  buttonLoading,
}) => {
  const isEdit = Boolean(selectedEntry);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (selectedEntry) {
      setForm({
        coordinatorId: selectedEntry.coordinatorId || "",
        slotName: selectedEntry.slotName || "",
      });
    } else {
      setForm({
        coordinatorId: "",
        slotName: "",
      });
    }
  }, [selectedEntry, open]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validate = () => {
    let temp = {};

    if (!form.slotName) temp.slotName = "Slot name is required";
    if (!form.coordinatorId) temp.coordinatorId = "Teacher is required";

    setErrors(temp);

    return Object.keys(temp).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const payload = {
      userId: cookies?.userId,
      coordinatorId: form.coordinatorId,
      timeTableId: selectedSlot?.timeTableId,
      slotId: selectedSlot?.slotId,
      slotName: form.slotName,
    };

    if (isEdit) {
      payload.entriesId = selectedEntry?.entriesId;
    }

    onSubmit(payload);
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600, color: "rgb(35, 71, 159)" }}>
        {isEdit ? "Edit Assignment" : "Assign Teacher"}
      </DialogTitle>

      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <TextField
            label="Slot Name *"
            value={form.slotName}
            onChange={(e) => handleChange("slotName", e.target.value)}
            error={!!errors.slotName}
            helperText={errors.slotName}
            fullWidth
          />

          <TextField
            label="Time"
            value={
              selectedSlot
                ? `${selectedSlot.startTime} - ${selectedSlot.endTime}`
                : ""
            }
            disabled
            fullWidth
          />

          <TextField
            select
            label="Teacher *"
            value={form.coordinatorId}
            onChange={(e) => handleChange("coordinatorId", e.target.value)}
            error={!!errors.coordinatorId}
            helperText={errors.coordinatorId}
            fullWidth
            sx={{ textTransform: "capitalize" }}
          >
            {coordinators?.map((c) => (
              <MenuItem
                key={c.userId}
                value={c.userId}
                sx={{ textTransform: "capitalize" }}
              >
                {c.name}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          loading={buttonLoading}
          sx={{
            backgroundColor: "rgb(35, 71, 159)",
            "&:hover": {
              backgroundColor: "rgb(28, 58, 130)",
            },
          }}
        >
          {isEdit ? "Update" : "Assign"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeTableForm;
